export * from './shared/gql/error-gql';
